// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * HTTP方法枚举 枚举类
 * HTTP方法枚举
 */
export enum EnumHTTPMethod {
  /** GET : GET */
  GET = 1,
  /** POST : POST */
  POST = 2,
  /** PUT : PUT */
  PUT = 4,
  /** DELETE : DELETE */
  DELETE = 8,
  /** HEAD : HEAD */
  HEAD = 16
}

/**
 * HTTP方法枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumHTTPMethodMD {
  private static items = [
    new EnumItemMD('GET', 1, 'GET', 'GET'),
    new EnumItemMD('POST', 2, 'POST', 'POST'),
    new EnumItemMD('PUT', 4, 'PUT', 'PUT'),
    new EnumItemMD('DELETE', 8, 'DELETE', 'DELETE'),
    new EnumItemMD('HEAD', 16, 'HEAD', 'HEAD')
  ];

  static getItem(enumItem: EnumHTTPMethod) {
    return this.items.find(item => item.name === EnumHTTPMethod[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
